import localStorageDB from "./LocalStorageDB";
import localIndexDB from "./LocalIndexDB";

export default new Promise((resolve) => {
  if (localIndexDB.opened === true) {
    resolve(localIndexDB);
  } else {
    localIndexDB.openDatabase().then((result) => {
      resolve(localIndexDB);
    }).catch((err) => {
      resolve(localStorageDB);
    });
  }
});



// WEBPACK FOOTER //
// ./src/services/LocalDatabase/GetLocalDB.js